module.exports = __webpack_public_path__ + "static/media/folder-minus.effb4f18.svg";